import {
  DeleteOutlined,
  DownloadOutlined,
  EditOutlined,
  ExclamationCircleOutlined,
  TeamOutlined,
} from '@ant-design/icons'
import { Button, Modal, Space, message } from 'antd'
import { inject, observer } from 'mobx-react'
import moment from 'moment'
import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet/es/Helmet'
import {
  EmptyText,
  TitleContentBox,
  WordBreak,
} from '../../../components/Common/CellText'
import FileItem from '../../../components/Common/FileItemComponent/FileItem'
import ContentBlockWrapper from '../../../components/ContentBlockWrapper'
import NormalTag from '../../../components/NormalTag/NormalTag'
import PageTitle from '../../../components/PageTitle'
import ReplyMessageInternal from '../../../components/ReplyMessageInternal'
import { systemName } from '../../../config'
import { DATE_FORMAT_SLASH, HH_mm } from '../../../constants'
import DashboardLayout from '../../../layouts/DashboardLayout'
import utils from '../../../utils'
import InternalMessageEditTitleModal from '../InternalMessageEditTitleModal'
import InternalMessageEditReceiversModal from '../InternalMessageEditReceiversModal'
import InternalMessageEditContentModal from '../InternalMessageEditContentModal'
import InternalMessageHistoryModal from '../InternalMessageHistoryModal'
import { MessageInfo } from './InternalMessageReceiveDetailPageStyled'

const { confirm } = Modal

const InternalMessageReceiveDetailPage = props => {
  const {
    location,
    internalMessageStore,
    match,
    history,
    loadingAnimationStore,
    authenticationStore,
  } = props
  const { currentUser } = authenticationStore
  const [isVisibleEditModal, setIsVisibleEditModal] = React.useState(false)
  const [
    isVisibleEditReceiversModal,
    setIsVisibleEditReceiversModal,
  ] = React.useState(false)
  const [
    isVisibleEditContentModal,
    setIsVisibleEditContentModal,
  ] = React.useState(false)
  const [isVisibleHistoryModal, setIsVisibleHistoryModal] = React.useState(
    false
  )
  const { internalMessageDetail, replyInternalMessages } = internalMessageStore

  const { code } = match.params

  useEffect(() => {
    ;(async () => {
      loadingAnimationStore.showSpinner(true)
      try {
        await internalMessageStore.getReceiveMessageById(code)
      } catch (error) {
        history.push('/utility/internal-message/receive')
        console.log(error)
        message.error(error?.vi || 'Đã có lỗi xảy ra!')
      } finally {
        loadingAnimationStore.showSpinner(false)
      }
    })()
    return () => internalMessageStore.clearMessageStore()
  }, [code])

  return (
    <DashboardLayout>
      <Helmet>
        <title>Tin nhắn liên thông | {systemName} Portal</title>
      </Helmet>
      <PageTitle
        location={location}
        showTitle={true}
        title={internalMessageDetail.title}>
        <Space>
          {/* <Button onClick={() => setIsVisibleHistoryModal(true)}>
            Lịch sử chỉnh sửa
          </Button> */}
          <Button
            icon={<DownloadOutlined />}
            onClick={async () => {
              try {
                loadingAnimationStore.showSpinner(true)
                await internalMessageStore.downloadAllZip()
              } catch (err) {
                message.error(err.message || 'Đã có lỗi xảy ra!')
              } finally {
                loadingAnimationStore.showSpinner(false)
              }
            }}>
            Tải tất cả đính kèm (.zip)
          </Button>
          {internalMessageDetail.owner === currentUser?.username && (
            <>
              {/* <Button
                icon={<EditOutlined />}
                type="primary"
                onClick={() => setIsVisibleEditContentModal(true)}>
                Chỉnh sửa nội dung
              </Button> */}
              <Button
                icon={<EditOutlined />}
                type="primary"
                onClick={() => setIsVisibleEditModal(true)}>
                Chỉnh sửa tiêu đề
              </Button>
              <Button
                icon={<TeamOutlined />}
                onClick={() => setIsVisibleEditReceiversModal(true)}>
                Chỉnh sửa người nhận
              </Button>
              <Button
                icon={<DeleteOutlined />}
                danger
                onClick={() => {
                  confirm({
                    title: 'Bạn có chắc chắn muốn xóa tin nhắn này?',
                    icon: <ExclamationCircleOutlined />,
                    content: 'Hành động này không thể hoàn tác.',
                    okText: 'Xóa',
                    okType: 'danger',
                    cancelText: 'Hủy',
                    async onOk() {
                      try {
                        loadingAnimationStore.showSpinner(true)
                        await internalMessageStore.softDelete(code)
                        message.success('Xóa tin nhắn thành công!')
                        history.push('/utility/internal-message/receive')
                      } catch (err) {
                        message.error(err?.vi || 'Đã có lỗi xảy ra!')
                      } finally {
                        loadingAnimationStore.showSpinner(false)
                      }
                    },
                  })
                }}>
                Xóa
              </Button>
            </>
          )}
        </Space>
      </PageTitle>
      <ContentBlockWrapper>
        <TitleContentBox>Thông tin</TitleContentBox>
        <MessageInfo>
          <dt>Người gửi</dt>
          <dd>
            <div className={'assign'}>
              {internalMessageDetail.owner_name ? (
                <NormalTag
                  noHover={true}
                  showFullTag={false}
                  tags={[{ name: internalMessageDetail.owner_name }].map(user =>
                    utils.getNameInCapitalize(user?.name?.toLowerCase())
                  )}
                />
              ) : (
                <EmptyText>Không rõ.</EmptyText>
              )}
            </div>
          </dd>
          <dt>Ngày gửi</dt>
          <dd>
            {internalMessageDetail.created_time ? (
              `${moment(internalMessageDetail.created_time).format(
                DATE_FORMAT_SLASH
              )} - ${moment(internalMessageDetail.created_time).format(HH_mm)}`
            ) : (
              <EmptyText>Không rõ.</EmptyText>
            )}
          </dd>
          <dt>Nội dung</dt>
          <dd>
            {internalMessageDetail.content ? (
              WordBreak(internalMessageDetail.content, true)
            ) : (
              <EmptyText>Không rõ.</EmptyText>
            )}
          </dd>
          <dt>Tài liệu đính kèm</dt>
          <dd>
            {internalMessageDetail.file_ids?.length > 0 ? (
              <>
                {internalMessageDetail.file_ids.map(file => (
                  <FileItem
                    key={file.file_id}
                    file_id={file.file_id}
                    file_name={file.name}
                    file_type={utils.getExtensionFile(file.name)}
                  />
                ))}
              </>
            ) : (
              <EmptyText>Không có.</EmptyText>
            )}
          </dd>
        </MessageInfo>
      </ContentBlockWrapper>
      <InternalMessageEditTitleModal
        isVisible={isVisibleEditModal}
        handleCancel={() => setIsVisibleEditModal(false)}
        code={internalMessageDetail.code}
        initialTitle={internalMessageDetail.title}
      />
      <InternalMessageEditContentModal
        isVisible={isVisibleEditContentModal}
        handleCancel={() => setIsVisibleEditContentModal(false)}
        code={internalMessageDetail.code}
        initialContent={internalMessageDetail.content}
      />
      <InternalMessageEditReceiversModal
        isVisible={isVisibleEditReceiversModal}
        handleCancel={() => setIsVisibleEditReceiversModal(false)}
        code={internalMessageDetail.code}
        receivers={internalMessageDetail.receiver}
        isReceive={true}
      />
      <ReplyMessageInternal
        replyInternalMessages={replyInternalMessages}
        code={code}
        internalMessageDetail={internalMessageDetail}
        isReceive={true}
      />
      <InternalMessageHistoryModal
        code={internalMessageDetail.code}
        isVisible={isVisibleHistoryModal}
        handleCloseHistory={() => setIsVisibleHistoryModal(false)}
      />
    </DashboardLayout>
  )
}

InternalMessageReceiveDetailPage.propTypes = {}

export default inject(
  'internalMessageStore',
  'selectUserStore',
  'loadingAnimationStore',
  'authenticationStore'
)(observer(InternalMessageReceiveDetailPage))
